import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './style.css';
import axios from "axios";
import { useConversation } from '~/helpers/store';
import { scrollChatToBottom } from '~/helpers/action';
import Spinner from '~/components/svg/Spinner';
import ReactMarkdown from 'react-markdown';

export default function Messages({ submitMessage, isChatSubmit, textStream }) {
    const { conversationId } = useParams();
    const [ isLoading, setIsLoading ] = useState(true);
    const [ allowQuestionListToBeClicked, setAllowQuestionListToBeClicked ] = useState(true);
    const convoState = useConversation((state) => state);

    useEffect(()=>{
        setIsLoading(true);
        axios.get(`/api/convos/messages/${conversationId}`).then((resp)=>{
            const { data } = resp;
            convoState.setMessage(data);
            setIsLoading(false);
        });
    }, [conversationId]);

    useEffect(()=>{
        scrollChatToBottom();
    }, [convoState.message])

    const getQuestions = () => {
        let questions = convoState.data.questionList.replaceAll("\n", "");
        questions = questions.split("• ");
        if(!questions) return;
        if(questions.length <= 1) {
            questions = convoState.data.questionList.split("\n*");
        }
        let ctr = 0;
        while (questions.length >= 4) {
            questions.splice(0, 1);
            ctr++;
            if(ctr > 3) break;
        }
        return questions;
    }

    return (
        <>
            <div className='conversation'>
                { isLoading ? <> <Spinner className="m-auto mt-5" /> </>
                :
                    <>
                    <div className="mb-[10px] mr-[15px]">
                        <img
                            className="inline-block mr-[10px]"
                            src="/assets/chatpdfv2-logo.png"
                            alt="ChatPDF"
                            width="20"
                        />
                        <span>
                        <b>Hello and Welcome to ChatPDF.</b><br></br>
                        </span>
                        { convoState.data.introduction ? 
                            <div style={{ marginTop: "5px" }}>{convoState.data.introduction}</div> 
                            : "It appears that the PDF you've uploaded contains some information that isn’t fully comprehensive. While we're currently unable to extract specific questions from the content, we encourage you to ask any questions you have or share topics you’d like to explore. We're here to help you navigate the material and discover interesting insights together. Let’s get started!" 
                        }
                        { convoState.data.questionList ? 
                            <div className="question-to-ask">
                                { 
                                    getQuestions().map((msg) => {
                                        return msg ? 
                                        <div onClick={
                                            () => {
                                                if(allowQuestionListToBeClicked) {
                                                    setAllowQuestionListToBeClicked(false);
                                                    submitMessage(msg, ()=>{
                                                        setAllowQuestionListToBeClicked(true);
                                                    });
                                                    scrollChatToBottom();
                                                }
                                            }
                                        }>
                                            <img src="/assets/send-message.svg" />{msg}
                                        </div> : ""
                                    })
                                }
                            </div>
                            : <></>
                        }
                    </div>
                    { convoState.message.map((msg)=>{
                        if(msg.sender.toLowerCase() === 'user') {
                            return <div className="user-chat"><span style={{
                                textAlign: "left"
                            }}>{ msg.text }</span></div>
                        } else {
                            return <div className="system-chat mb-[10px] mr-[15px]">
                                <img
                                className="inline-block mr-[10px]"
                                src="/assets/chatpdfv2-logo.png"
                                alt="ChatPDF"
                                width="20"
                            /> <span><ReactMarkdown>{ msg.text }</ReactMarkdown></span>
                            </div>
                        }
                    })}
                    { isChatSubmit ?
                        <div className="loading-chat">
                            <div></div>
                        </div> : <></>
                    }
                    {
                        convoState.isStreaming && textStream ? 
                            <div className="system-chat mb-[10px] mr-[15px]">
                                <img
                                className="inline-block mr-[10px]"
                                src="/assets/chatpdfv2-logo.png"
                                alt="ChatPDF"
                                width="20"
                            /> <span><ReactMarkdown>{ textStream }</ReactMarkdown></span>
                            </div> : <></>
                    }
                    </>
                }
            </div>
        </>
    );
}